import HttpService from "./HttpService";

let alunoService = {

    buscarListaDeAlunos: () => {
        return HttpService.backApi.get('/alunos');
    },

    buscarListaParaLaudo: (search) => {
        return HttpService.backApi.get(`/alunos/laudo?search=${search}`)
    },

    salvarAluno: (aluno) => {
        return HttpService.backApi.put('/alunos/salvar', aluno);
    },

    updateAluno: (aluno) => {
        return HttpService.backApi.put('/alunos/update', aluno);
    },

    deletarAluno: (aluno) => {
        return HttpService.backApi.delete(`/alunos/${aluno.id}`)
    },

    buscarAvaliacoes: (idAluno) => {
        return HttpService.backApi.get(`/alunos/avaliacoes/${idAluno}`)
    },

    gerarSenha: (idAluno) => {
        return HttpService.backApi.get(`/alunos/${idAluno}/gerar-senha`, { responseType: 'blob' });
    }
};

export default alunoService;
